import { Draggable, DraggableProvided } from 'react-beautiful-dnd';
import { ListItem, ListItemButton, ListItemText } from '@mui/material';
import styled from 'styled-components';
import { createPortal } from 'react-dom';

export const ListItemStyled = styled(ListItem) <{ dragging?: number; background?: string }>`
  background-color: ${({ background, draggable }) => (background ? background : draggable && 'rgb(235,235,235)')};
  border: ${({ background, theme }) => background && `1px solid ${theme.palette.grey[700]}`};
  margin: ${({ background }) => background && '2px 0 0 0'};
  height: ${({ background }) => background && '4vh'};
  max-height: ${({ background }) => background && '40px'};
`;

export type DraggableListItemProps = {
  id: string;
  index: number;
  text: string;
  backgroundColor?: string;
  textHexColor?: string;
};

const renderListItem = (provided: DraggableProvided, text: string, backgroundColor?: string, textHexColor?: string, isDragging = false) => {

  return (
    <ListItemStyled
      ref={provided.innerRef}
      disablePadding
      background={backgroundColor}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      dragging={isDragging ? 1 : 0}
    >
      <ListItemButton dense>
        <ListItemText primary={text} sx={{ color: textHexColor }} />
      </ListItemButton>
    </ListItemStyled>
  );
};

export const DraggableListItem = ({ id, index, text, backgroundColor, textHexColor }: DraggableListItemProps) => (
  <Draggable key={id} draggableId={id} index={index}>
    {(provided, snapshot) => {

      return snapshot.isDragging ? createPortal(
        renderListItem(provided, text, backgroundColor, textHexColor, true), document.body)
        :
        renderListItem(provided, text, backgroundColor, textHexColor);
    }}
  </Draggable>
);
